import NewsletterSubscriptionBanner from './NewsletterSubscriptionBanner';

export default {
    NewsletterSubscriptionBanner,
};
